module.exports = __webpack_public_path__ + "static/media/NoRestaurants.8a6733d0.png";